export class Tab {
    constructor() {
        this.tabs = Array.from(document.querySelectorAll('.tabbed-list li'));
        this.tabContent = Array.from(document.querySelectorAll('.tabbed-content__detail'));

        // Add click event listener to each tab
        this.tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => {
                // Remove active class from all tabs
                this.tabs.forEach((tab) => tab.classList.remove('active'));

                // Add active class to the clicked tab
                tab.classList.add('active');

                // Fade out the current active tab content
                const currentContent = document.querySelector('.tabbed-content__detail.active');
                this.fadeOut(currentContent, () => {
                    // Remove active class from all tab content elements
                    this.tabContent.forEach((content) => content.classList.remove('active'));

                    // Fade in the new active tab content
                    this.tabContent[index].classList.add('active');
                    this.tabContent[index].querySelector('.accordion__title').classList.add('active');
                    this.fadeIn(this.tabContent[index]);
                });
            });
        });
        if (this.tabs.length > 0) {
            // Set the first tab and its corresponding content as active by default
            this.tabs[0].classList.add('active');
            this.tabContent[0].classList.add('active');
            this.tabContent[0].querySelector('.accordion__title').classList.add('active');
        }
    }

    // Function to fade out an element
    fadeOut(element, callback) {
        let opacity = 1;
        const duration = 300; // Animation duration in milliseconds
        const startTime = performance.now();

        const fadeOutAnimation = (timestamp) => {
            const elapsed = timestamp - startTime;
            opacity = 1 - (elapsed / duration);

            if (opacity > 0) {
                element.style.opacity = opacity.toFixed(2);
                requestAnimationFrame(fadeOutAnimation);
            } else {
                element.style.opacity = '0';
                element.style.display = 'none';
                callback();
            }
        };

        requestAnimationFrame(fadeOutAnimation);
    }

    // Function to fade in an element
    fadeIn(element) {
        let opacity = 0;
        const duration = 300; // Animation duration in milliseconds
        const startTime = performance.now();
        element.style.display = 'block';

        const fadeInAnimation = (timestamp) => {
            const elapsed = timestamp - startTime;
            opacity = elapsed / duration;

            if (opacity < 1) {
                element.style.opacity = opacity.toFixed(2);
                requestAnimationFrame(fadeInAnimation);
            } else {
                element.style.opacity = '1';
            }
        };

        requestAnimationFrame(fadeInAnimation);
    }
}
